import { controls } from "../controls";

const ecompliancehome = {
  label: "Home",
  pageLabel: "Dashboard",
  starting: true,
  url: "home",
  pageType: "history",
  visitingBranches: true,
  dashboard: [
    // ...controls.dashboardsGenerator()
    ...controls.displayText({ width: "col-sm-12", label: " ", tab: "filter" }),




    {
      widths: "col-lg-4 col-md-4 col-sm-12",
      tab: "create",
      title: "Inspecting Officer Status",
      footer: "",
      forrole: "HOIT",
      formodule: "audit",
      theme: "orotheme",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          clickable: true,
          showvalues: false,
          name: "kpi_list",
          ddType: "rpad2",
          dformat: { label: "user_display", format: "progress", fastpath: "#rpad2", value: "assigned" },// "simple_tick",
        }),
      ]
    },







    {
      widths: "col-lg-4 col-md-4 col-sm-12",
      tab: "create",
      title: "MENU",
      footer: "",
      forrole: "HOIT",
      formodule: "audit",
      theme: "orotheme",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          clickable: true,
          showvalues: false,

          values: [
            { main: { url: "queries", value: "icon-tick", color: "green", desc: "Queries" } },
            { main: { url: "query_groups", value: "icon-tick", color: "green", desc: "Query Groups" } },
            { main: { url: "editor", value: "icon-tick", color: "green", desc: "Editor" } },
            { main: { url: "roles", value: "icon-tick", color: "green", desc: "Roles" } },
            { main: { url: "users", value: "icon-tick", color: "green", desc: "Create Users" } },
            { main: { url: "error_logs", value: "icon-tick", color: "green", desc: "Error Logs" } },
            { main: { url: "assign_auditors", value: "icon-tick", color: "green", desc: "Assign Inspecting Officer" } },
            { main: { url: "widgets", value: "icon-tick", color: "green", desc: "Widgets" } },
          ]
        }),
      ]
    },
    {
      widths: "col-lg-4 col-md-4 col-sm-12",
      tab: "create",
      title: "REPORTS",
      footer: "",
      theme: "orotheme",
      forrole: "HOIT",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          clickable: true,
          showvalues: false,

          values: [
            { main: { url: "rpad1", value: "icon-tick", color: "green", desc: "Consolidated" } },
            { main: { url: "rpad4", value: "icon-tick", color: "green", desc: "Non-Compliance" } },
            { main: { url: "rpad3", value: "icon-tick", color: "green", desc: "Branch Wise Compliance" } },
            { main: { url: "rpad2", value: "icon-tick", color: "green", desc: "Inspecting Officers Status" } },

            { main: { url: "rpad8", value: "icon-tick", color: "green", desc: "Bank Inspection Status" } },
            { main: { url: "rpad7", value: "icon-tick", color: "green", desc: "State Inspection Status" } }
          ]
        }),
      ]
    },


    {
      widths: "col-sm-6",
      tab: "create",
      title: "Bank Wise",
      footer: "",
      forrole: "HOIT",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad8",
          format: ""
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "State Level Consolidated",
      footer: "",
      forrole: "HOIT",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad7",
          format: ""
        }),
      ]
    },

    {
      widths: "col-sm-12",
      tab: "create",
      title: "Overall Progress",
      footer: "",
      forrole: "Auditor",
      formodule: "audit",
      subComponents: [
        ...controls.progressBar({
          width: 12,
          ddType: "rpad18",
          format: "",
          dformat: { label: "display_name", format: "progress", completeBy: "deadline", fastpath: "fastpath", value: "status", displayType: "tick" },
          values: { value: 78, items: [{ name: "branch 1", value: 12 }, { name: "branch 2", value: 82 }] }
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "Inspection Checklist",
      footer: "Inspection status for the selected branch",
      forrole: "Auditor",//forrole: "Inspecting Officer",
      formodule: "audit",
      theme: "orotheme",
      selfWhatsApp: "sendsummary",
      title2name: "insdeadline",
      subComponents: [
        ...controls.kpiList({
          showvalues: true,
          clickable: true,
          name: "kpi_list",
          ddType: "rpad18",
          dformat: { label: "display_label", format: "aduitorchecklist", lift: { completeBy: "insdeadline" }, fastpath: "fastpath", value: "status", displayType: "tick", hasvar3: "label_uid" }
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      notforuser: "apex",
      title: "Reports",
      footer: "",
      forrole: "Auditor",//forrole: "Inspecting Officer",
      formodule: "audit",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          clickable: true,
          values: [
            { main: { url: "rpad13", value: "icon-tick", color: "green", desc: "Compliance Details" } },
            { main: { url: "rpad24", value: "icon-tick", color: "green", desc: "Non-Compliance Details" } },
            // { main: { url: "rpad15", value: "icon-tick", color: "green", desc: "Compliance Status" } },

            { main: { url: "rpad18", value: "icon-tick", color: "green", desc: "Status Wise Branch" } },
            { main: { url: "rpad19", value: "icon-tick", color: "green", desc: "Status Wise Consolidated " } },
            { main: { url: "feedbacks", value: "icon-tick", color: "green", desc: "Submit Feedback" } }

          ]
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "Branch Wise",
      footer: "",
      forrole: "Auditor",//forrole: "Inspecting Officer",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad18",
          format: ""
        }),
      ]
    },


    {
      widths: "col-sm-6",
      tab: "create",
      title: "My Branches Consolidated Status",
      footer: "",
      forrole: "Auditor",//forrole: "Inspecting Officer",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad19",
          format: ""
        }),
      ]
    },














    {
      widths: "col-sm-6",
      tab: "create",
      title: "Branch Inspection Status",
      footer: "",
      theme: "orotheme",
      forrole: "Branch Manager",
      formodule: "audit",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          showvalues: true,
          clickable: true,
          name: "kpi_list",
          ddType: "rpad18",
          dformat: { label: "display_label", format: "aduitorchecklist", lift: { completeBy: "insdeadline" }, fastpath: "fastpath", value: "status", displayType: "tick", hasvar3: "label_uid" }
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "Recompliance Needed",
      footer: "",
      theme: "orotheme",
      forrole: "Branch Manager",
      formodule: "audit",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          showvalues: true,
          clickable: true,
          name: "kpi_list",
          ddType: "rpad181",
          dformat: { label: "display_label", format: "recompliance", fastpath: "fastpath", value: "inspection_status", hasvar3: "label_uid" }
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      notforuser: "apex",
      title: "DCC Reports",
      footer: "",
      // style:{border:"none"},
      forrole: "Branch Manager",
      formodule: "audit",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          clickable: true,
          values: [
            { main: { url: "rpad13", value: "icon-tick", color: "green", desc: "Compliance Report" } },
            { main: { url: "rpad24", value: "icon-tick", color: "green", desc: "Non-Compliance Report" } },
            { main: { url: "rpad18", value: "icon-tick", color: "green", desc: "Status Wise Branch Report" } },]
        }),
      ]
    },

    // {
    //   widths: "col-sm-6",
    //   tab: "create",
    //   title: "Non-Compliance Status",
    //   footer: "",
    //   theme: "orotheme",
    //   forrole: "Branch Manager",
    //   formodule: "audit",
    //   selfWhatsApp: "sendsummary",
    //   subComponents: [
    //     ...controls.nivoChart({
    //       charttype: "bar"
    //     }),
    //   ]
    // },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "Status",
      footer: "",
      forrole: "Branch Manager",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad16",
          format: ""
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "DCC Banks Branch Inspection Status",
      footer: "",
      theme: "orotheme",
      forrole: "DCC Bank Administrator",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          clickable: false,
          showvalues: true,
          emptymsg: "Inspection Inspection not started",
          name: "kpi_list",
          ddType: "rpad22",
          dformat: { label: "display_name", format: "pending", completeBy: "deadline", fastpath: "fastpath", value: "status", displayType: "tick" }
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      notforuser: "apex",
      title: "All Branch Status",
      footer: "",
      forrole: "DCC Bank Administrator",
      formodule: "audit",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          clickable: true,
          values: [
            { main: { url: "rpad13", value: "icon-tick", color: "green", desc: "Branch Compliance" } },
            { main: { url: "rpad24", value: "icon-tick", color: "green", desc: "Branch Non-Compliance" } },
            { main: { url: "rpad35", value: "icon-tick", color: "green", desc: "Bank Non-Compliance" } },
            { main: { url: "rpad33", value: "icon-tick", color: "green", desc: "Bank Consolidated" } },

            { main: { url: "rpad16", value: "icon-tick", color: "green", desc: "Status Wise Branch" } },
            { main: { url: "rpad37", value: "icon-tick", color: "green", desc: "Status Wise Bank" } }

          ]
        }),
      ]
    },


    {
      widths: "col-sm-6",
      tab: "create",
      title: "Branch Wise",
      footer: "",
      forrole: "DCC Bank Administrator",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad16",
          format: ""
        }),
      ]
    },

    {
      widths: "col-sm-6",
      tab: "create",
      title: "Bank Level Consolidated",
      footer: "",
      forrole: "DCC Bank Administrator",
      formodule: "audit",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.nivoChart({
          width: 12,
          charttype: "bar",
          ddType: "rpad37",
          format: ""
        }),
      ]
    },


    // assign DCC - select dcc, select date. on submit insert into 

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Upload Data - CBS",
      footer: "From Finacle",
      forrole: "DCC Bank Administrator",
      formodule: "reporting",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          clickable: true,
          showvalues: false,
          name: "kpi_list",
          values: [
            { main: { desc: "PACS Financial Position", url: "upload_pacs_statics", value: "16/12/2021", color: "green" } },
            { main: { desc: "PACS OTS", url: "upload_pacs_otss", value: "16/12/2021", color: "green" } },
            { main: { desc: "Trial Balance", url: "upload_trial_balances", value: "10/12/2021", color: "green" } },

            { main: { desc: "Receipt Payment", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Overdue GL", url: "gls", value: "icon-cross", color: "red", message: "GL 12009 is not present in the master." } },
            { main: { desc: "Outstanding Accounts", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Disbursed Accounts", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Overdue Accounts", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Digital Transactions", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Card Disbursement", url: "gls", value: "icon-cross", color: "red" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Generated Reports",
      forrole: "DCC Bank Administrator",
      formodule: "reporting",
      footer: "Generated Reports",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          clickable: true,
          showvalues: false,
          name: "kpi_list",
          values: [
            { main: { desc: "Monthly Financial 101-m", url: "rp101o", value: "12/12/2021", color: "green" } },
            { main: { desc: "PACS Financial Position", url: "pacs_financial_position_bank", value: "15/12/2021", color: "green" } },
            { main: { desc: "PACS OTS Report", url: "pacs_ots_bank", value: "15/12/2021", color: "green" } },
            { main: { desc: "Statement 108-C", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Annual Recovery", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Basic Data", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Financial Position - Annual", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Selected Statistics", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Staff Position", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Statement 108-A", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Statement 113-A", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Administration Report", url: "slbchome_2", value: "icon-cross", color: "red" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Report Verification Status",
      forrole: "DCC Bank Administrator",
      formodule: "reporting",
      footer: "Reports accepted / reverted / rejected by the APEX Bank",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Monthly Financial 101-m", url: "report_acceptances", value: "12/12/2021", color: "green" } },
            { main: { desc: "PACS Financial Position", url: "report_acceptances", value: "15/12/2021", color: "green" } },
            { main: { desc: "PACS OTS Report", url: "report_acceptances", value: "15/12/2021", color: "green" } },
            { main: { desc: "Statement 108-C", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Annual Recovery", url: "report_acceptances", value: "icon-cross", color: "red" } },

            { main: { desc: "Basic Data", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Financial Position - Annual", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Selected Statistics", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Staff Position", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Statement 108-A", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Statement 113-A", url: "report_acceptances", value: "icon-cross", color: "red" } },
            { main: { desc: "Administration Report", url: "report_acceptances", value: "icon-cross", color: "red" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Generated Reports",
      forrole: "HOIT",
      formodule: "reporting",
      footer: "Generated Reports",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          clickable: true,
          showvalues: false,
          name: "kpi_list",
          values: [
            { main: { desc: "Monthly Financial 101-m", url: "rp101m", value: "12/12/2021", color: "green" } },
            { main: { desc: "PACS Financial Position", url: "pacs_financial_position_bank", value: "15/12/2021", color: "green" } },
            { main: { desc: "PACS OTS Report", url: "pacs_ots_bank", value: "15/12/2021", color: "green" } },
            { main: { desc: "Statement 108-C", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Annual Recovery", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Basic Data", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Financial Position - Annual", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "Selected Statistics", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Staff Position", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Statement 108-A", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Statement 113-A", url: "slbchome_2", value: "icon-cross", color: "red" } },
            { main: { desc: "Administration Report", url: "slbchome_2", value: "icon-cross", color: "red" } },
          ]
        }),
      ]
    },


    {
      widths: "col-sm-4",
      tab: "create",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "Pendency",
      forrole: "DCC Bank Administrator",
      formodule: "reporting",
      footer: "As of last quarter",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "September 2021", url: "apexpendency", value: "icon-cross", color: "red" } }
          ]
        }),
      ]
    },









    // {
    //   widths: "col-sm-12",
    //   tab: "create",
    //   selfWhatsApp: "sendsummary",
    //   title: "All DCC Status",
    //   // style:{border:"none"},
    //   footer: "for the current quarter",
    //   subComponents: [
    //     ...controls.gchart({
    //       charttype: "timeline"
    //     }),
    //   ]
    // },



  ]
};

export default ecompliancehome;